import React from 'react';
import {
  Cpu, LayoutGrid, Server, Database, CheckSquare, Activity, Terminal, Layers,
  BarChart3, Users, Github, Linkedin, Instagram, Mail, Sun, Moon, GitBranch, TrendingUp, Star,
  Code2, Smartphone, Cloud, ShieldCheck, PanelsTopLeft,
} from 'lucide-react';

const MAP = {
  cpu: Cpu, grid: LayoutGrid, server: Server, database: Database, check: CheckSquare,
  activity: Activity, terminal: Terminal, layers: Layers, chart: BarChart3, users: Users,
  github: Github, linkedin: Linkedin, instagram: Instagram, mail: Mail, sun: Sun, moon: Moon,
  branch: GitBranch, trending: TrendingUp, star: Star,
  code: Code2, smartphone: Smartphone, cloud: Cloud, shield: ShieldCheck, layout: PanelsTopLeft,
};

export default function Icon({ name, ...rest }) {
  const C = MAP[name] || Activity;
  return <C strokeWidth={2} {...rest} />;
}
